import { z } from 'zod/v4';

const envSchema = z.object({ VITE_API_URL: z.url() });
type EnvConfig = z.infer<typeof envSchema>;

declare global {
  interface Window {
    __MOLCHANOVS_RUNTIME_CONFIG__?: { version: number; apiUrl: string };
  }
}

function validApiOrigin(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.origin !== value || url.username || url.password) {
      return undefined;
    }
    return value;
  } catch {
    return undefined;
  }
}

function getEnv(): EnvConfig {
  const runtimeConfig =
    typeof window === 'undefined' ? undefined : window.__MOLCHANOVS_RUNTIME_CONFIG__;
  const runtimeApiUrl =
    runtimeConfig?.version === 1 ? validApiOrigin(runtimeConfig.apiUrl) : undefined;

  // Vite's local server uses the existing development URL. Deployed builds
  // require a complete public config generated by the container at startup.
  const apiUrl =
    runtimeApiUrl ??
    (import.meta.env.DEV ? (import.meta.env.VITE_API_URL ?? 'http://localhost:4000') : undefined);
  if (apiUrl === undefined) {
    throw new Error('Missing or invalid public Web runtime config: WEB_API_URL');
  }
  return envSchema.parse({ VITE_API_URL: apiUrl });
}

export const env = getEnv();
